import React from "react";

export default (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3C6.61615 3 3 7.48618 3 12C3 16.5138 6.61615 21 12 21C17.3839 21 21 16.5138 21 12C21 7.48618 17.3839 3 12 3ZM1 12C1 6.51382 5.38385 1 12 1C18.6161 1 23 6.51382 23 12C23 17.4862 18.6161 23 12 23C5.38385 23 1 17.4862 1 12Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 6C12.5523 6 13 6.44772 13 7V13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V7C11 6.44772 11.4477 6 12 6Z"
      fill="white"
    />
    <path
      d="M13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z"
      fill="white"
    />
  </svg>
);
